module.exports = __webpack_public_path__ + "static/media/ini5-180w.0d72f37c.jpg";